import { ApolloError } from '@apollo/client';

import ComponentLoading from '../../shared/component-loading';
import {
  PlayableComponentButton,
  PlayableComponentButtonText,
} from '../../shared/playable-component.style';

const InteractiveResponseStart = ({
  title,
  label,
  isLoggedIn,
  hasFetchedAnswers,
  error,
  onStart,
}: {
  title: string;
  label: string;
  isLoggedIn: boolean;
  hasFetchedAnswers: boolean;
  error?: ApolloError;
  onStart: () => void;
}) => {
  return isLoggedIn && (!hasFetchedAnswers || error) ? (
    <ComponentLoading hasData={hasFetchedAnswers} error={error} />
  ) : (
    <PlayableComponentButton
      type="button"
      aria-label={`Open to start ${label} response: ${title}`}
      onClick={onStart}
      data-selector="btn-start"
    >
      <PlayableComponentButtonText>Open</PlayableComponentButtonText>
    </PlayableComponentButton>
  );
};

export default InteractiveResponseStart;
